import {LINKPOP_API_HOST} from '../config/linkpop-api';

const fetchQuery = async ({
  query,
  variables = {},
  headers,
  url,
  onError,
  requestId,
}: {
  query: string;
  variables?: Record<string, any>;
  headers?: {};
  url?: string;
  onError?: (error: any) => void;
  requestId?: string;
}) => {
  const GRAPHQL_ENDPOINT = url || `https://${LINKPOP_API_HOST}/graphql`;
  console.log('sending a post request', {GRAPHQL_ENDPOINT, requestId});
  try {
    const queryHeaders: HeadersInit = {
      'Content-Type': 'application/json',
      ...headers,
    };

    if (requestId) {
      queryHeaders['x-linkpop-correlation-id'] = requestId;
    }

    if (!url) {
      queryHeaders['x-shopify-react-xhr'] = '1';
    }

    const response = await fetch(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: queryHeaders,
      body: JSON.stringify({
        query,
        variables,
      }),
    });
    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    console.error('Error fetching from', {error, requestId});
    if (onError) {
      onError(error);
    }
    return null;
  }
};

export default fetchQuery;
